import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { ButtonToolbar, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";

import { API_URL } from "@api/constants";
import { Api } from "@api/index";
import { UploadButton } from "@api/components/UploadButton";
import { AuthState } from "@auth/models";
import { StateError } from "@orm/models";
import { Icon } from "@ui/Icon";
import { ErrorAlert } from "@ui/ErrorAlert";
import { getExcelSpreadsheetAccept } from "@util/index";
import { messages } from "../../messages";
import { canCreateBundle } from "../../selectors";

interface BundleUploaderOwnProps {
    onSuccess?: (id: number) => void;
}

interface BundleUploaderStateProps {
    canCreate: boolean;
}

interface BundleUploaderState {
    error: StateError;
}

type State = AuthState;
type Props = BundleUploaderOwnProps & BundleUploaderStateProps;

class BundleUploader extends React.Component<Props, BundleUploaderState> {
    constructor(props: Props) {
        super(props);

        this.state = {error: null};
    }

    private onSuccess(response: any) {
        const { onSuccess } = this.props;
        if (onSuccess != null) {
            onSuccess(Number(response));
        }
    }

    public render() {
        const { canCreate } = this.props;
        const { error } = this.state;
        return (
            <div className="bundle-uploader">
                {canCreate &&
                    <div>
                        <ButtonToolbar key="buttons" className="mb-3">
                            <UploadButton
                                actionCreator={(file: File) => {
                                    this.setState({ error: null });
                                    return Api.bundlesStore(file);
                                }}
                                onError={(e: StateError) => { this.setState({ error: e }); }}
                                onSuccess={this.onSuccess.bind(this)}
                                color="primary"
                                className="mr-2"
                                accept={getExcelSpreadsheetAccept()}
                            >
                                <Icon name="upload" />
                                {" "}
                                <FormattedMessage {...messages.upload} />
                            </UploadButton>
                            <Button
                                key="download-metadata"
                                tag="a"
                                href={API_URL + "downloads/bundle-metadata.xlsm"}
                            >
                                <Icon name="download" />
                                {" "}
                                <FormattedMessage {...messages.downloadEmptyMetadata} />
                            </Button>
                        </ButtonToolbar>

                        {error != null && <ErrorAlert error={error} />}

                        <div key="instructions">
                            <p><FormattedMessage {...messages.instructionsUpload1} /></p>
                            <p><FormattedMessage {...messages.instructionsUpload2} /></p>
                            <p>
                                <FormattedMessage
                                    {...messages.instructionsUpload3}
                                    values={{
                                        link: (chunks) =>
                                            <a
                                                href={API_URL + "downloads/bundle-metadata.xlsx"}>{chunks}
                                            </a>,
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: State): BundleUploaderStateProps => ({
    canCreate: canCreateBundle(state),
});

const ConnectedBundleUploader = compose<Props, BundleUploaderOwnProps>(
    connect(mapStateToProps, null),
)(BundleUploader);

export {
    BundleUploader as BundleUploaderPresenter,
    ConnectedBundleUploader as BundleUploader,
};
